class Grupo {
    id: Number = 0;
    nome: String = "";
    d_E_L_E_T_E: boolean = false;
    criadoEm: Date = new Date();
    excluidoEm: Date = new Date();
}

export default Grupo;
